import React, { useState } from "react";
import Dropdown from "./Dropdown";
import "./ItemCategory.css";

const ItemCategory = ({
  data,
  onChange,
  foodstyles,
  menuCategories,
  podCategories,
  xpressChef,
  onDiscard,
  onNext,
}) => {
  console.log("podCategories ", podCategories);
  const foodTypesData = [
    { title: "Non Veg", value: "NonVegetarian" },
    { title: "Egg", value: "Eggetarian" },
    { title: "Veg", value: "Vegetarian" },
  ];

  const { category, menuCategory, forCategories, foodType, foodStyle } = data;
  const [openDropdown, setOpenDropdown] = useState(null);

  const handleSelectFoodType = (item) => {
    onChange({ ...data, foodType: item });
    setOpenDropdown(null);
  };

  const handleSelectFoodStyle = (item) => {
    onChange({ ...data, foodStyle: item.title });
    setOpenDropdown(null);
  };

  const handleSelectPodCategory = (item) => {
    onChange({ ...data, category: item });
    setOpenDropdown(null);
  };

  const handleSelectMenuCategory = (selectedItems) => {
    onChange({ ...data, menuCategory: selectedItems });
    setOpenDropdown(null);
  };

  const handleSelectForCategories = (selectedItems) => {
    onChange({ ...data, forCategories: selectedItems });
    setOpenDropdown(null);
  };

  const toggleDropdown = (dropdown) => {
    if (openDropdown === dropdown) {
      setOpenDropdown(null);
    } else {
      setOpenDropdown(dropdown);
    }
  };

  return (
    <div className="item-category-container">
      <h2 className="category-text">Category</h2>
      <hr className="separator" />
      <div className="food-type-container">
        {xpressChef ? (
          <>
            <div>
              <label className="menu-category-text">Pod Category</label>
              <Dropdown
                options={podCategories}
                onSelect={handleSelectPodCategory}
                selectedValue={category}
                placeholder="Select"
                isOpen={openDropdown === "podCategory"}
                onToggle={() => toggleDropdown("podCategory")}
              />
            </div>
          </>
        ) : (
          <div>
            <label className="menu-category-text">Menu Category</label>
            <Dropdown
              options={menuCategories}
              onSelect={handleSelectMenuCategory}
              placeholder="Select"
              multiSelect={true}
              maxSelect={2}
              selectedItems={menuCategory}
              isOpen={openDropdown === "menuCategory"}
              onToggle={() => toggleDropdown("menuCategory")}
            />
          </div>
        )}
        <div>
          <label className="menu-category-text">Falls Under</label>
          <Dropdown
            options={foodTypesData}
            onSelect={handleSelectFoodType}
            selectedValue={foodType.title}
            placeholder="Select"
            isOpen={openDropdown === "foodType"}
            onToggle={() => toggleDropdown("foodType")}
          />
        </div>
        <div>
          <label className="menu-category-text">Style</label>
          <Dropdown
            options={foodstyles}
            onSelect={handleSelectFoodStyle}
            selectedValue={foodStyle}
            placeholder="Select"
            isOpen={openDropdown === "foodStyle"}
            onToggle={() => toggleDropdown("foodStyle")}
          />
        </div>
      </div>

      <div className="dropdown-group">
        {category?.toUpperCase() === "ADD ONS" ? (
          <div>
            <label className="menu-category-text">For Categories</label>
            <Dropdown
              options={podCategories.filter(
                (item) => item?.toUpperCase() !== "ADD ONS"
              )}
              onSelect={handleSelectForCategories}
              placeholder="Select For Categories"
              multiSelect={true}
              maxSelect={6}
              selectedItems={forCategories}
              isOpen={openDropdown === "forCategories"}
              onToggle={() => toggleDropdown("forCategories")}
            />
          </div>
        ) : null}
      </div>
      <div className="button-group">
        <button className={`discard-button`} onClick={onDiscard}>
          Back
        </button>
        <button
          className={`next-button ${
            !(xpressChef
              ? category
              : menuCategory && foodType.title && foodStyle)
              ? "disabled"
              : ""
          }`}
          onClick={onNext}
          disabled={
            xpressChef
              ? !category
              : !menuCategory.length || !foodType.title || !foodStyle
          }
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default ItemCategory;
